export const focusItemLookup = event => {
    const trigger = event.target.closest('[data-focus-item-lookup]');

    if (!trigger) {
        return;
    }

    const lookup = trigger.closest('form').querySelector('#new-order-sku-lookup');

    event.preventDefault();

    lookup.scrollIntoView({behavior: 'smooth', block: 'center'});
    lookup.focus();
};

export const revealSection = event => {
    const trigger = event.target.closest('[data-reveal]');

    if (!trigger) {
        return;
    }

    const section = trigger.closest('form').querySelector(trigger.dataset.reveal);

    event.preventDefault();

    section.hidden = false;
    trigger.hidden = true;
    section.querySelector('input, textarea')?.focus();
};

export const holdItemLookupSubmission = event => {
    if (event.key !== 'Enter' || !event.target.matches('#new-order-sku-lookup')) {
        return;
    }

    event.preventDefault();
};

export const applyItemChangeOnEnter = event => {
    if (event.key !== 'Enter' || !event.target.matches('#new-order-items tbody input:not([type=hidden])')) {
        return;
    }

    event.preventDefault();
    event.target.blur();
};
